/**
 * This is an unpublished work containing 3M confidential and proprietary information.
 * Disclosure, use or reproduction without the written authorization of 3M is prohibited.
 * If publication occurs, the following notice applies:
 * Copyright (C) 2025, 3M. All rights reserved.
 */
import React, { RefObject } from "react";
import { MobileLayout } from "./MobileLayout";
import { TabletLayout } from "./TabletLayout";
import { GalleryMode } from "../PromptGallery/data/galleryTypes";
import { DesktopLayout } from "./DesktopLayout";

interface MainContentProps {
  galleryState: {
    current: { mode: GalleryMode | null; direction: number };
    goToModeWithDirection: (
      mode: GalleryMode | null,
      direction: number,
    ) => void;
    exitDirectionRef: RefObject<number>;
    isAnimating: boolean;
    setIsAnimating: (value: boolean) => void;
    setExitDirectionRef: RefObject<((direction: number) => void) | null>;
    isFirstAnimationRunning: boolean;
    setIsFirstAnimationRunning: (value: boolean) => void;
  };
  onNavigateToChat?: (message: string, tools?: string[]) => void;
  deviceType: "mobile" | "tablet" | "desktop";
  showPromptLibrary?: boolean;
  onClosePromptLibrary?: () => void;
}

export function MainContent({
  galleryState,
  onNavigateToChat,
  deviceType,
  showPromptLibrary,
  onClosePromptLibrary,
}: MainContentProps) {
  // Responsive horizontal padding strategy: minimize margins early (0→1→2→6) then restore wider spacing progressively.
  // Removed items-center so children (ChatInput, Gallery) can span full available width before shrinking.
  return (
    <main className="flex-1 min-h-0 flex flex-col items-stretch bg-[var(--main-background)] relative overflow-hidden">
      {deviceType === "tablet" ? (
        <TabletLayout
          galleryState={galleryState}
          onNavigateToChat={onNavigateToChat}
        />
      ) : deviceType === "mobile" ? (
        <MobileLayout
          galleryState={galleryState}
          onNavigateToChat={onNavigateToChat}
        />
      ) : (
        <DesktopLayout
          galleryState={galleryState}
          onNavigateToChat={onNavigateToChat}
          showPromptLibrary={showPromptLibrary}
          onClosePromptLibrary={onClosePromptLibrary}
        />
      )}
    </main>
  );
}
